module.exports = __webpack_public_path__ + "img/pants side seam length.d0c58570.png";